module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('a', {
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.goToHome($event)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logo.png"),
      "id": "logo",
      "height": "100",
      "alt": "Logo iZZi"
    }
  })]), _vm._v(" "), _c('h1', [_vm._v("iZZi transfert")]), _vm._v(" "), _c('p', [_vm._v("\n      Transférez vos fichiers en toute simplicité.\n    ")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('div', {
    staticClass: "has-text-centered"
  }, [_c('p', [_vm._v("\n        © 2017" + _vm._s(new Date().getFullYear() > 2017 ? ("-" + (new Date().getFullYear())) : '') + " iZZi Transfert\n        |\n        "), _c('a', {
    attrs: {
      "href": "http://www.izziweb.fr/mentions-legales/",
      "target": "_blank"
    }
  }, [_vm._v("Mentions légales")]), _vm._v("\n        |\n        "), _c('a', {
    attrs: {
      "href": "http://www.izziweb.fr/#contact-section",
      "target": "_blank"
    }
  }, [_vm._v("Contact")])])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5640f6ef!./~/vue-loader/lib/selector.js?type=template&index=0!./app/src/components/App.vue
// module id = 129
// module chunks = 0